"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Toaster as Sonner } from "sonner";
export const Toaster = () => {
    return (_jsx(Sonner, { position: "top-right", closeButton: true, toastOptions: {
            classNames: {
                success: "bg-[#a8c5a4] text-[#2d2520] border-[#a8c5a4]",
                error: "bg-[#d4183d] text-white border-[#d4183d]",
                info: "bg-[#8fa9c0] text-[#2d2520] border-[#8fa9c0]",
                warning: "bg-[#f5d77e] text-[#2d2520] border-[#f5d77e]",
            },
        } }));
};
